
import { RouteObject } from "react-router-dom";
import { lazy } from "react";

const HomePage = lazy(() => import("../pages/home/page"));
const WinterLeaguePage = lazy(() => import("../pages/winter-league/page"));
const SpringLeagueRegistrationPage = lazy(() => import("../pages/spring-league-registration/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/winter-league",
    element: <WinterLeaguePage />,
  },
  {
    path: "/spring-league-registration",
    element: <SpringLeagueRegistrationPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
